import type { JSX } from 'react';
import { Toaster as SonnerToaster, toast, type ToasterProps } from 'sonner';

export function Toaster(props: ToasterProps): JSX.Element {
  return (
    <SonnerToaster
      theme="light"
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'var(--card)',
          color: 'var(--card-foreground)',
          border: '1px solid var(--border)',
        },
      }}
      {...props}
    />
  );
}

/** Reemplaza a `showNotification` de Mantine — mismo shape {color, message, autoClose}. */
export function notify({ color, message, autoClose = 4000 }: { color: 'green' | 'red' | 'yellow'; message: string; autoClose?: number | false }): void {
  const duration = autoClose === false ? Infinity : autoClose;
  if (color === 'green') toast.success(message, { duration });
  else if (color === 'red') toast.error(message, { duration });
  else toast(message, { duration });
}
